// src/components/Termini.jsx
import React from "react";

export default function Termini() {
    return (
        <div className="max-w-4xl mx-auto px-6 py-10">
            <h1 className="text-2xl font-bold mb-6">
                CONDIZIONI GENERALI DI CONTRATTO NORMA® HACCP – Food Safety Pilot (Servizio
                SaaS)
            </h1>

            <div className="prose max-w-none">
                <p>
                    Accettate il: <strong>[data_ora]</strong>
                    <br />
                    Le presenti Condizioni Generali di Contratto (“Condizioni”) sono stipulate
                    tra:
                    <br />
                    <strong>[nome_cliente] [società]</strong>, con sede in{" "}
                    <strong>[indirizzo_cliente_società] – [cap] [città] ([provincia])</strong>,
                    P.IVA <strong>[piva]</strong> (di seguito “Cliente”);
                    <br />
                    e
                    <br />
                    MadOut Srl, con sede legale in Roma, Via della Stazione di Ottavia, 57D –
                    00135 Roma, P.IVA IT15643551003 (di seguito “Fornitore”).
                </p>

                <h2>Premesse</h2>
                <p>
                    Le Parti convengono e stipulano quanto segue:
                    <br />
                    il Fornitore sviluppa e commercializza applicativi digitali, inclusi servizi
                    software in modalità SaaS, tra cui il software denominato “NORMA® HACCP –
                    Food Safety Pilot” (“Software” o “Servizio”);
                    <br />
                    il Cliente ha manifestato interesse a usufruire del Servizio;
                    <br />
                    le presenti Condizioni si applicano a tutti i servizi e piani di licenza
                    scelti dal Cliente, in abbonamento, anche in forma di pacchetti e/o moduli
                    aggiuntivi;
                    <br />
                    il piano di licenza e le condizioni economiche applicate sono definite
                    mediante proposta commerciale, ordine, e-mail, area clienti, telefono o
                    altre comunicazioni concordate tra le Parti.
                    <br />
                    Le premesse formano parte integrante e sostanziale del presente contratto.
                </p>

                <h2>Art. 1 – Descrizione del Servizio</h2>
                <p>
                    1.1 Il Fornitore mette a disposizione del Cliente una piattaforma digitale
                    finalizzata alla gestione e organizzazione dell’HACCP e delle attività di
                    controllo nell’ambito della ristorazione e dell’alimentazione, erogata in
                    modalità SaaS (“Servizio”).
                    <br />
                    1.2 Il Servizio consente al Cliente, a titolo esemplificativo e non esaustivo, di:
                    <br />
                    a- digitalizzare e gestire piani, procedure e documentazione HACCP;
                    <br />
                    b- compilare e archiviare registri digitali (es. temperature, sanificazioni,
                    non conformità, abbattimenti, ricevimento merci, etichettatura, controlli periodici);
                    <br />
                    c- gestire utenti e profili con ruoli differenziati (es. Amministratore, Operatore)
                    secondo il piano sottoscritto;
                    <br />
                    d- consultare dashboard operative e riepiloghi storici;
                    <br />
                    e- conservare allegati e documenti con tracciabilità delle attività e log applicativi;
                    <br />
                    f- ricevere notifiche e alert operativi, ove previsti;
                    <br />
                    g- utilizzare funzionalità di supporto automatizzato tramite modulo “Norma AI”,
                    ove previsto dal piano;
                    <br />
                    h- integrare dispositivi IoT compatibili, inclusi sensori “CRYO – Cold Chain Guard”,
                    per la rilevazione e registrazione automatica di parametri (es. temperature) secondo
                    disponibilità e configurazione tecnica.
                    <br />
                    1.3 Il Servizio costituisce uno strumento gestionale e di supporto operativo. Resta
                    inteso che il Servizio non sostituisce consulenze professionali e non garantisce
                    automaticamente l’assenza di non conformità o sanzioni. La responsabilità della corretta
                    applicazione delle procedure HACCP e del rispetto delle norme vigenti resta in capo al Cliente.
                    <br />
                    1.4 Formazione e supporto. Il Servizio comprende una fase di formazione iniziale (secondo
                    il piano sottoscritto) e supporto nell’utilizzo del Software. L’assistenza tecnica potrà essere
                    richiesta tramite e-mail ai recapiti indicati all’Art. 15. Il Fornitore si impegna a fornire riscontro
                    entro 72 (settantadue) ore lavorative dalla richiesta, salvo casi complessi o periodi di picco.
                    <br />
                    1.5 Evoluzioni del Software. Il Fornitore potrà aggiornare, modificare o migliorare il Software per
                    esigenze tecniche, evolutive, di sicurezza o normative, garantendo la continuità delle funzionalità
                    essenziali del piano sottoscritto.
                    <br />
                    1.6 Promozioni. Il Fornitore si riserva la facoltà di realizzare condizioni promozionali o offerte speciali.
                    Tali condizioni non modificano automaticamente il contratto già in essere, salvo accordo espresso.
                </p>

                <h2>Art. 2 – Modalità di apertura dell’Account</h2>
                <p>
                    2.1 Per usufruire del Servizio, il Cliente dovrà fornire i dati necessari alla configurazione dell’account,
                    inclusi a titolo esemplificativo: denominazione attività, indirizzo, dati societari, contatti, orari, logo e
                    materiali utili.
                    <br />
                    2.2 Il Cliente potrà procedere:
                    <br />
                    a- in autonomia tramite le procedure di onboarding e configurazione previste dal Software; oppure
                    <br />
                    b- richiedendo supporto al Fornitore.
                    <br />
                    2.3 In caso di intervento del Fornitore, l’account verrà creato entro 72 (settantadue) ore lavorative dalla
                    ricezione dei dati completi e corretti, con invio delle credenziali di accesso.
                    <br />
                    2.4 Accettazione. L’accesso e l’uso dell’account comportano l’accettazione integrale delle presenti Condizioni.
                    L’accettazione viene registrata tramite log applicativo con data e ora.
                    <br />
                    2.5 Prova gratuita. Qualora prevista, il Cliente potrà utilizzare il Software fino alla scadenza della prova gratuita.
                    Alla scadenza, il Cliente non ha obbligo di rinnovo. Per proseguire l’uso, dovrà sottoscrivere un piano a pagamento.
                </p>

                <h2>Art. 3 – Durata, rinnovo, cessazione e dati</h2>
                <p>
                    3.1 Il Servizio è erogato in abbonamento con durata mensile o annuale, secondo il piano sottoscritto.
                    <br />
                    3.2 Attivazione. Il Servizio sarà attivato a seguito della ricezione dell’accredito del pagamento o della conferma
                    del metodo di pagamento concordato.
                    <br />
                    3.3 Rinnovo.
                    <br />
                    a- Abbonamento mensile: si rinnova automaticamente di mese in mese, salvo disdetta del Cliente comunicata per iscritto
                    almeno 15 (quindici) giorni prima della scadenza mensile.
                    <br />
                    b- Abbonamento annuale: si rinnova automaticamente per ulteriori 12 mesi, salvo disdetta comunicata per iscritto almeno
                    30 (trenta) giorni prima della scadenza annuale.
                    <br />
                    3.4 Mancato pagamento. In caso di mancato pagamento o di pagamento non andato a buon fine, il Fornitore potrà sospendere
                    l’accesso al Servizio fino alla regolarizzazione, senza responsabilità per eventuali conseguenze operative.
                    <br />
                    3.5 Disattivazione e conservazione dati. In caso di mancato rinnovo o cessazione, il Servizio verrà disattivato decorso
                    un periodo tecnico di 7 (sette) giorni dalla scadenza. I dati saranno conservati per un periodo massimo di 90 (novanta)
                    giorni, decorso il quale verranno cancellati o anonimizzati, salvo obblighi di legge o necessità tecniche.
                    <br />
                    3.6 Backup e sicurezza. Il Fornitore adotta misure tecniche e organizzative di sicurezza e procedure di backup coerenti
                    con lo stato dell’arte. Resta inteso che il Cliente è responsabile dell’eventuale esportazione e conservazione autonoma
                    dei dati in caso di cessazione del Servizio, nei limiti delle funzionalità di esportazione disponibili.
                </p>

                <h2>Art. 3-bis – Dispositivi IoT e sensori CRYO – Cold Chain Guard</h2>
                <p>
                    3-bis.1 Il Servizio può integrare dispositivi IoT compatibili, inclusi sensori “CRYO – Cold Chain Guard”, per la rilevazione
                    automatica di parametri (es. temperatura) e la registrazione nel Software, ove previsto dal piano e dalla configurazione tecnica.
                    <br />
                    3-bis.2 Proprietà dei dispositivi.
                    <br />
                    a- In caso di acquisto: i dispositivi restano di proprietà del Cliente.
                    <br />
                    b- In caso di comodato d’uso: i dispositivi restano di proprietà del Fornitore o di soggetti terzi autorizzati.
                    <br />
                    3-bis.3 Restituzione comodato. In caso di cessazione del contratto, i dispositivi concessi in comodato dovranno essere restituiti
                    entro 15 (quindici) giorni dalla cessazione, a cura e spese del Cliente, salvo diverso accordo. In caso di mancata restituzione,
                    il Fornitore avrà diritto di fatturare al Cliente il valore commerciale dei dispositivi non restituiti.
                    <br />
                    3-bis.4 Condizioni tecniche. Il funzionamento dei dispositivi IoT dipende anche da connettività internet, alimentazione e
                    infrastruttura locale del Cliente. Il Fornitore non risponde di malfunzionamenti imputabili a cause esterne, installazioni non conformi
                    o manomissioni.
                </p>

                <h2>Art. 15 – Comunicazioni</h2>
                <p>
                    15.1 Le comunicazioni ufficiali tra le Parti dovranno avvenire per iscritto.
                    <br />
                    15.2 Per assistenza e comunicazioni operative: <strong>[email_assistenza]</strong> (es. assistenza@norma-haccp.com)
                    <br />
                    15.3 Per PEC: <strong>[pec_fornitore]</strong> (se disponibile)
                </p>

                <h2>Art. 14 – Legge applicabile e foro competente</h2>
                <p>
                    Il presente contratto è disciplinato dalla legge italiana. Per ogni controversia è competente in via esclusiva il Tribunale di Roma.
                </p>
            </div>
        </div>
    );
}